export class EnvironmentConstants {
  static development = "development";
  static production = "production";
}
